import { Grid, TextField } from "@mui/material";
import { FieldLabel } from "./FieldLabel";
import { UseFormRegister } from "react-hook-form";
import { FieldErrors } from "react-hook-form/dist/types/errors";
import { CreateFormInput } from "~/components/FormFields/types";

export default function CompanyField({
  errors,
  register,
}: {
  errors: FieldErrors<{ company: string }>;
  register: UseFormRegister<CreateFormInput>;
}) {
  return (
    <Grid size={{ xs: 12 }} container gap={1}>
      <FieldLabel
        id="company-name-input"
        label="Company name"
        caption={`Define a company name for this organization to use within the UI.`}
      />
      <TextField
        id="company-name-input"
        fullWidth
        placeholder="Company name"
        variant="outlined"
        slotProps={{
          input: {
            sx: { backgroundColor: "code.background" },
          },
        }}
        error={Boolean(errors.company)}
        {...register("company")}
      />
    </Grid>
  );
}
